var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3513 8.7705L15.7527 7.36915C16.1781 6.94372 16.3909 6.731 16.5046 6.50153C16.7209 6.06493 16.7209 5.55234 16.5046 5.11574C16.3909 4.88627 16.1781 4.67355 15.7527 4.24811C15.3273 3.82268 15.1145 3.60996 14.8851 3.49625C14.4485 3.2799 13.9359 3.2799 13.4993 3.49625C13.2698 3.60996 13.0571 3.82268 12.6317 4.24812L11.2126 5.66714C11.9647 6.95503 13.0463 8.02833 14.3513 8.7705ZM10.0778 6.80199L4.71701 12.1628C4.38535 12.4944 4.21952 12.6603 4.11049 12.864C4.00146 13.0677 3.95547 13.2977 3.86349 13.7576L3.38332 16.1584C3.33141 16.418 3.30546 16.5477 3.37928 16.6215C3.4531 16.6954 3.58286 16.6694 3.84238 16.6175L6.24322 16.1373C6.70315 16.0453 6.93311 15.9993 7.13684 15.8903C7.34056 15.7813 7.50639 15.6155 7.83805 15.2838L13.2136 9.90829C11.9482 9.11582 10.878 8.05287 10.0778 6.80199Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.2deab28d.svg";
export { ForwardRef as ReactComponent };